var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2558 15.5752C6.25805 15.5731 4.34275 14.7785 2.93013 13.3659C1.51751 11.9533 0.722957 10.038 0.720796 8.04023C0.624725 2.4166 7.01943 -1.36911 11.8921 1.45275L12.8672 1.99402L11.8983 2.54658C7.6913 4.86234 7.99898 11.2558 12.4007 13.1621L13.4185 13.6211L12.4974 14.2528C11.2499 15.1127 9.77091 15.5739 8.2558 15.5752Z",
    fill: "#942020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.d3bf491a2f04132d38f54228509318ab.svg";
export { ForwardRef as ReactComponent };